import React, { useEffect, useState } from "react";
import axios from "axios";
import { Notify } from "notiflix";
import CommonProfileCard from "../CommonProfileCard/CommonProfileCard";
import ProfileSkeleton from "../ProfileSkeleton/ProfileSkeleton";

const RecentProfileSection = () => {
    const [showAll, setShowAll] = useState(false);
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [Reload, setReload] = useState(false);

    const visibleProfiles = showAll ? profiles : profiles.slice(0, 4);

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem("kkm_auth"));
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        setLoading(true);
        axios
            .get(
                "https://kovaikongunadumatrimony.com/kkm_backend/public/api/recent-profile",
                { headers }
            )
            .then((response) => {
                if (response.data.status === true) {
                    setProfiles(response.data.data);
                } else {
                    Notify.failure(response.data.message);
                }
            })
            .catch(() => {
                Notify.failure("Something went wrong while fetching profiles.");
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <div className={`all-profiles-section ${showAll ? "scrollable" : ""}`}>
            <h2>Recent Profile ({profiles.length})</h2>
            <div className="row profiles-grid">
                {loading
                    ? Array.from({ length: 4 }).map((_, index) => (
                          <div className="col-xl-6 col-12 mb-4" key={index}>
                              <ProfileSkeleton />
                          </div>
                      ))
                    : visibleProfiles.reverse().map((profile, index) => (
                          <div className="col-xl-6 col-12 mb-4" key={index}>
                              <CommonProfileCard
                                  profile={profile}
                                  setReload={setReload}
                              />
                          </div>
                      ))}
            </div>
            {!loading && profiles.length > 4 && (
                <div className="view-all-wrapper">
                    <button
                        className="view-all-btn"
                        onClick={() => setShowAll(!showAll)}
                    >
                        {showAll ? "Show Less" : "View All"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default RecentProfileSection;
